/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any(),
}
).strict();
const relationSchema = z.object({
    listing: z.record(z.string(), z.unknown()),
    user: z.record(z.string(), z.unknown()),
    files: z.array(z.unknown()).optional(),
    replies: z.array(z.unknown()).optional(),
}
);
const fkSchema = z.object({
    listingId: z.string(),
    userId: z.string(),
}
);

/**
 * `Comment` schema excluding foreign keys and relations.
 */
export const CommentScalarSchema = baseSchema;


/**
 * `Comment` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const CommentSchema = CommentScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const CommentPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const CommentPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any()
}).partial().passthrough();


/**
 * `Comment` schema for create operations excluding foreign keys and relations.
 */
export const CommentCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `Comment` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const CommentCreateSchema = CommentCreateScalarSchema.merge(fkSchema);


/**
 * `Comment` schema for update operations excluding foreign keys and relations.
 */
export const CommentUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Comment` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const CommentUpdateSchema = CommentUpdateScalarSchema.merge(fkSchema.partial());

